import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function emailValidator(control: AbstractControl): ValidationErrors | null {
  const email = control.value;
  
  if (!email) return null;
  
  const valid = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
  
  return valid ? null : { email: true };
}

export function phoneValidator(control: AbstractControl): ValidationErrors | null {
  const phone = control.value;
  
  if (!phone) return null;

  const valid = /^\d+$/.test(phone);
  
  return valid ? null : { phone: true };
}


// Strong password validator - requires uppercase, lowercase, number, and special character
export function strongPasswordValidator(control: AbstractControl): ValidationErrors | null {
  const password = control.value;

  if (!password) return null;

  const errors: ValidationErrors = {};

  if (password.length < 8) {
    errors['minLength'] = true;
  }
  if (!/[A-Z]/.test(password)) {
    errors['noUppercase'] = true;
  }
  if (!/[a-z]/.test(password)) {
    errors['noLowercase'] = true;
  }
  if (!/[0-9]/.test(password)) {
    errors['noNumber'] = true;
  }
  if (!/[!@#$%^&*(),.?":{}|<>_\-+=\[\]\\;'/`~]/.test(password)) {
    errors['noSpecial'] = true;
  }

  return Object.keys(errors).length > 0 ? errors : null;
}

// Password match validator for confirm password
export function passwordMatchValidator(passwordField: string, confirmPasswordField: string): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    const password = formGroup.get(passwordField)?.value;
    const confirmPassword = formGroup.get(confirmPasswordField)?.value;

    if (!confirmPassword) return null;

    if (password !== confirmPassword) {
      formGroup.get(confirmPasswordField)?.setErrors({ passwordMismatch: true });
      return { passwordMismatch: true };
    }

    const confirmControl = formGroup.get(confirmPasswordField);
    if (confirmControl?.hasError('passwordMismatch')) {
      delete confirmControl.errors?.['passwordMismatch'];
      if (Object.keys(confirmControl.errors || {}).length === 0) {
        confirmControl.setErrors(null);
      }
    }

    return null;
  };
}

// Custom URL validator function
export function validateUrl(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    // Allow empty values (combine with Validators.required if needed)
    if (!control.value) {
      return null;
    }

    // Official URL regex from Angular Material (modified for flexibility)
    const urlRegex = /^(https?:\/\/)?([\w-]+\.)+[\w-]+([\w-.;@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?$/i;

    // Test the value against the regex
    const isValid = urlRegex.test(control.value);

    // Return error object if invalid, null if valid
    return isValid ? null : { invalidUrl: true };
  };
}
